const tabs = {
  details: [
    {index: 0,
      key: 'destination',
      label: 'תאריכים ויעד'},
    {index: 1,
      key: 'insured',
      label: 'מבוטחים'},
    {index: 2,
      key: 'medical',
      label: 'שאלון רפואי'},
    {
      index: 3,
      key: 'medical_extended',
      label: 'שאלון רפואי - מורחב',
    },
    {index: 4,
      key: 'coverage',
      label: 'כיסויים קיימים'},
  ],
  offers: [
    {index: 0,
      key: 'list',
      label: 'list'},
  ],
};

export default (includeExtended = false) => {
  const clonedTabs = JSON.parse(JSON.stringify(tabs));
  if (!includeExtended) {
    clonedTabs.details = clonedTabs.details.filter((tab) => tab.key !== 'medical_extended');
  }
  return clonedTabs;
};

